import { render, staticRenderFns } from "./FeaturedCreator.vue?vue&type=template&id=34749b70&scoped=true"
import script from "./FeaturedCreator.vue?vue&type=script&lang=js"
export * from "./FeaturedCreator.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCreator.vue?vue&type=style&index=0&id=34749b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34749b70",
  null
  
)

export default component.exports